import JSZip from "jszip";
import { Image } from "./p5";
import { saveAs } from "file-saver";

interface PushPoppable {
	push(): void;
	pop(): void;
}

export function PushPop<T>(f: () => T, target?: PushPoppable | undefined): T {
	target ? target.push() : push();
	const v = f();
	target ? target.pop() : pop();
	return v;
}

interface BeginEndable {
	begin(): void;
	end(): void;
}

export function BeginEnd<T>(f: () => T, target: BeginEndable): T {
	target.begin();
	push();
	const v = f();
	pop();
	target.end();
	return v;
}

type windowIndexable = Record<string | symbol, (...args: any[]) => void>;

export function OnGraphic<T>(
	f: (g: p5.Graphics) => T,
	target?: p5.Graphics | undefined
): T {
	if (target === undefined) {
		target = new Proxy<p5.Graphics>({} as p5.Graphics, {
			get(target, prop, receiver) {
				return (...args: any[]) => {
					const w = window as unknown as windowIndexable;
					w[prop](...args);
				};
			},
		});
	}

	return f(target);
}

export async function LoadBase64Png(b64: string): Promise<Image> {
	return await loadImage(`data:image/png;base64,${b64}`);
}

export interface Pixel {
	Red: number;
	Green: number;
	Blue: number;
	Alpha: number;
}

export function ReadPixel(x: number, y: number, w: number = width): Pixel {
	const i = (x + y * width) * 4;

	const p: Pixel = { Red: 0, Green: 0, Blue: 0, Alpha: 0 };
	p.Red = pixels[i + 0];
	p.Green = pixels[i + 1];
	p.Blue = pixels[i + 2];
	p.Alpha = pixels[i + 3];

	return p;
}

export function SetPixel(x: number, y: number, p: Pixel, w: number = width) {
	const i = (x + y * width) * 4;

	pixels[i + 0] = p.Red;
	pixels[i + 1] = p.Green;
	pixels[i + 2] = p.Blue;
	pixels[i + 3] = p.Alpha;
}

// https://github.com/processing/p5.js/issues/2326?

export async function ExportFrames(count: number) {
	const zip = new JSZip();

	for (let i = 0; i < count; i++) {
		draw();

		const frame = get() as unknown as {
			canvas: HTMLCanvasElement;
		};

		let data = frame.canvas.toDataURL(undefined, 1);
		data = data.slice(22);
		zip.file(`${i.toString().padStart(10, "0")}.png`, data, {
			base64: true,
		});
	}

	const data = await zip.generateAsync({ type: "blob" });
	saveAs(data, "frames.zip");
}

export function SetCanvasPositionByTarget(elem: HTMLCanvasElement, targetQS: string){
	const targetElem = document.querySelector(targetQS)
	if (targetElem === null) {
		throw new Error("Could not find target");
	}
	targetElem.parentElement?.replaceChild(elem, targetElem);
}